(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_account-buy-again"] && !Shopify.designMode) return;
  try {
    /* Buy Again — Sort + Load More
     ----------------------------------------------------------------
     1. Sort: reorders all grid children (visible and hidden) by
        the selected key, partitioning available products first.
     2. Load more: reveals the next batch of 24 hidden items.
     3. Sort resets visible count to 24 (first batch in new order).
  */
  (function () {
    var BATCH_SIZE = 24;
    var grid = document.querySelector('[data-buy-again-grid]');
    var sortSelect = document.querySelector('[data-buy-again-sort]');
    var loadMoreBtn = document.querySelector('[data-buy-again-load-more]');

    if (!grid) return;

    /* ---- Helpers -------------------------------------------------------- */

    function getAllItems() {
      return Array.prototype.slice.call(grid.querySelectorAll('[data-buy-again-item]'));
    }

    function getVisibleCount() {
      var items = getAllItems();
      var count = 0;
      for (var i = 0; i < items.length; i++) {
        /* First 24 are visible via CSS; beyond that, need .is-visible */
        if (i < BATCH_SIZE || items[i].classList.contains('is-visible')) {
          count++;
        } else {
          break;
        }
      }
      return Math.min(count, items.length);
    }

    function updateLoadMoreVisibility() {
      if (!loadMoreBtn) return;
      var items = getAllItems();
      var totalVisible = 0;
      for (var i = 0; i < items.length; i++) {
        if (i < BATCH_SIZE || items[i].classList.contains('is-visible')) {
          totalVisible++;
        }
      }
      if (totalVisible >= items.length) {
        loadMoreBtn.setAttribute('hidden', '');
      } else {
        loadMoreBtn.removeAttribute('hidden');
      }
    }

    /* ---- Sort ----------------------------------------------------------- */

    function sortItems(key) {
      var items = getAllItems();

      items.sort(function (a, b) {
        /* Partition: available first, unavailable last */
        var aAvail = a.getAttribute('data-product-available') === 'true' ? 0 : 1;
        var bAvail = b.getAttribute('data-product-available') === 'true' ? 0 : 1;
        if (aAvail !== bAvail) return aAvail - bAvail;

        /* Secondary sort by selected key */
        if (key === 'recent') {
          return parseInt(a.getAttribute('data-sort-recency'), 10) -
                 parseInt(b.getAttribute('data-sort-recency'), 10);
        }
        if (key === 'frequency') {
          var diff = parseInt(b.getAttribute('data-order-count'), 10) -
                     parseInt(a.getAttribute('data-order-count'), 10);
          if (diff !== 0) return diff;
          /* Tie-break by recency */
          return parseInt(a.getAttribute('data-sort-recency'), 10) -
                 parseInt(b.getAttribute('data-sort-recency'), 10);
        }
        if (key === 'alpha') {
          var titleA = (a.getAttribute('data-product-title') || '').toLowerCase();
          var titleB = (b.getAttribute('data-product-title') || '').toLowerCase();
          return titleA.localeCompare(titleB);
        }
        return 0;
      });

      /* Reset visibility: remove all is-visible classes */
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('is-visible');
      }

      /* Re-append in sorted order (moves, doesn't clone) */
      for (var j = 0; j < items.length; j++) {
        grid.appendChild(items[j]);
      }

      updateLoadMoreVisibility();
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        sortItems(this.value);
      });
    }

    /* ---- Load More ------------------------------------------------------ */

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        var items = getAllItems();
        var revealed = 0;
        for (var i = BATCH_SIZE; i < items.length; i++) {
          if (!items[i].classList.contains('is-visible')) {
            items[i].classList.add('is-visible');
            revealed++;
            if (revealed >= BATCH_SIZE) break;
          }
        }
        updateLoadMoreVisibility();
      });
    }

    /* ---- Initial state -------------------------------------------------- */
    updateLoadMoreVisibility();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_account-orders"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var ROOT_SEL = '.c-account-orders';
    var root = document.querySelector(ROOT_SEL);
    if (!root) return;

    var allDetails = root.querySelectorAll('details.c-account-orders__accordion');
    var filterTabs = root.querySelectorAll('.c-account-orders__filter-tab');
    var cards = root.querySelectorAll('.c-account-orders__card');

    /* -- Helper: fetch cart count and dispatch cart:update with correct detail -- */
    function notifyCartUpdate() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                data: { itemCount: cart.item_count, source: 'account-orders' }
              }
            })
          );
        })
        .catch(function () { /* silent */ });
    }
    var liveRegion = root.querySelector('.c-account-orders__live-region');

    /* =====================================================================
       QUANTITY CEILINGS (B2C-284)
       =====================================================================
       Every add on this block goes through window.CasinettoCart — there is no
       raw fetch left. Per-item add is a single-item add(), so it is NOT silent
       and the module fires the one toast itself. Reorder-all is bulk: ONE
       addMany() call for the whole order, and this block composes ONE
       aggregated toast from the index-aligned `ceilings` it returns. addMany
       fires no toast and takes no `silent` — a twelve-line order cannot produce
       a sensible single message (D14 §4), and one call keeps reorder at two
       requests rather than one press costing twenty.

       Neither path calls check(), and reorder-all does not call it per row:
       check() is for a surface that paints a quantity before the mutation
       returns, neither of these does, and inside addMany the allocation IS the
       pre-flight (decisions/quantity-ceilings-structure.md D13, D14 §5).

       The per-item ceiling values live on the .c-account-orders__line-item row,
       emitted by snippets/quantity-ceiling-attrs.liquid. */
    var MAX_NAMED = 2; /* the aggregated toast names at most two blocked items */

    function cartApi() {
      if (window.CasinettoCart && window.CasinettoCart.add) { return window.CasinettoCart; }
      return null;
    }

    function fillCount(template, count) {
      if (!template) return '';
      return template.split('__COUNT__').join(String(count));
    }

    function ceilingParams(row) {
      var d = (row && row.dataset) || {};
      return {
        productId: d.productId,
        title: d.productTitle || '',
        cap: d.maxQty,
        stock: d.stock,
        orderLimitMessage: d.msgOrderLimit
      };
    }

    function reasonText(ceiling) {
      var d = root.dataset;
      if (ceiling.reason === 'ORDER_LIMIT') { return fillCount(d.bulkMsgOrderLimit, ceiling.limit); }
      if (ceiling.reason === 'SOLD_OUT_ADD') { return d.bulkMsgSoldOutAdd || ''; }
      return fillCount(d.bulkMsgStockBlocked, ceiling.limit);
    }

    /* One toast for the whole reorder: up to two blocked items with their
       reason, then a count of the remainder. Critical only if a policy cap was
       hit — running out of stock is not an error (spec §5). */
    function announceBlocked(blocked) {
      if (!window.CasinettoToast || !blocked.length) return;
      var d = root.dataset;
      var lines = [];
      var critical = false;
      var i;

      for (i = 0; i < blocked.length && i < MAX_NAMED; i++) {
        lines.push({ title: blocked[i].title, text: reasonText(blocked[i].ceiling) });
      }
      if (blocked.length > MAX_NAMED) {
        lines.push(fillCount(d.bulkMsgMore, blocked.length - MAX_NAMED));
      }
      for (i = 0; i < blocked.length; i++) {
        if (blocked[i].ceiling.reason === 'ORDER_LIMIT') { critical = true; break; }
      }

      window.CasinettoToast.show({
        variant: critical ? 'critical' : 'info',
        message: d.bulkMsgSummary || '',
        lines: lines
      });
    }

    /* =====================================================================
       KEEPING THE CUSTOMER'S PLACE (B2C-323)
       =====================================================================
       Switching orders (§1) and collapsing a long list (§0) remove content
       above what the customer is looking at. Both read that element's
       viewport top, make the change, then scroll back by the difference in
       ONE instant step. html is `scroll-behavior: smooth` (base.css), so the
       correction suspends it inline on the root and restores the previous
       inline value. Never `behavior: 'instant'`: older Safari throws on a
       value it does not know in the options dictionary.

       Scroll anchoring is switched off ONLY around a correction, inline on
       the root, and restored on the next frame. Chromium anchors and would
       correct a second time; iOS Safari does not anchor at all, so during a
       correction the JS is the only compensator in every browser. Not a
       page-wide rule: with anchoring off at rest, every scroll-up on a phone
       moved the content by the logo bar's height on top of the scroll
       (156px for a 100px scroll in the harness's header model). */
    function scrollByInstantly(dy) {
      var rootEl = document.documentElement;
      var previous = rootEl.style.scrollBehavior;
      rootEl.style.scrollBehavior = 'auto';
      try {
        window.scrollBy(0, dy);
      } finally {
        rootEl.style.scrollBehavior = previous;
      }
    }

    /* Run `change`, then scroll so `el` is back at its viewport top. The
       measure and the scroll are wrapped so a failed correction never blocks
       the change itself: the change always runs, only the correction is lost.
       The second measure is taken after the change, so the browser's clamp at
       the end of the page is already in it. */
    function keepInPlace(el, change) {
      var rootEl = document.documentElement;
      var previousAnchor = rootEl.style.overflowAnchor;
      var before = null;
      try {
        rootEl.style.overflowAnchor = 'none';
        before = el.getBoundingClientRect().top;
      } catch (err) {
        before = null;
      }
      try {
        change();
        if (before !== null) {
          try {
            var delta = el.getBoundingClientRect().top - before;
            if (delta) scrollByInstantly(delta);
          } catch (err) {
            /* The change stands; only the correction is lost. */
          }
        }
      } finally {
        /* Next frame, so the browser's own anchoring pass for this change
           still sees `none`. Never left set: this runs even if the change
           throws. */
        requestAnimationFrame(function () {
          rootEl.style.overflowAnchor = previousAnchor;
        });
      }
    }

    /* =====================================================================
       0. LINE-ITEMS EXPANDER (D31; B2C-323, formerly §6)
       =====================================================================
       JS owns the collapsed state. Liquid renders every row visible and the
       bar `hidden`, so a page whose script never runs shows every item and
       no control that does nothing. This section runs ahead of everything
       else that touches the orders, in this order:
         1. the bar's click handler is attached, so no row is ever hidden
            before the control that shows it again is live;
         2. per order, the bar is shown FIRST and rows 5+ are hidden SECOND,
            so a failure part-way leaves extra rows and a working bar;
         3. an order whose bar or list is missing is skipped, never thrown
            on, so the accordion, filter tabs and deep link below still run.
       Running before the deep link (§3) means openDetail measures the
       collapsed height. Rows are found through the bar's aria-controls list,
       so a bar can only ever touch its own order's rows. */

    var VISIBLE_ROWS = 4;

    function expanderRows(bar) {
      var listId = bar.getAttribute('aria-controls');
      var list = listId ? document.getElementById(listId) : null;
      if (!list) return null;
      return list.querySelectorAll('.c-account-orders__line-item');
    }

    /* The one state function for an order's list. Collapsed: rows 5+ hidden,
       aria-expanded/data-expanded false, "Show all N items". Expanded: the
       opposite, "Show fewer items". Returns false, changing nothing, when the
       order's list cannot be found. */
    function setExpanded(bar, expanded) {
      var rows = expanderRows(bar);
      if (!rows) return false;

      for (var i = VISIBLE_ROWS; i < rows.length; i++) {
        if (expanded) {
          rows[i].removeAttribute('hidden');
        } else {
          rows[i].setAttribute('hidden', '');
        }
      }

      bar.setAttribute('data-expanded', expanded ? 'true' : 'false');
      bar.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      var textEl = bar.querySelector('.c-account-orders__expander-text');
      var label = expanded
        ? bar.getAttribute('data-label-hide')
        : fillCount(bar.getAttribute('data-label-show'), bar.getAttribute('data-count'));
      if (textEl && label) textEl.textContent = label;
      return true;
    }

    /* Expand (H1, B2C-323): reveal rows 5+, then move focus to the first
       revealed item: row 5's "Add", or row 5 itself when it has no enabled
       "Add" (buttons switched off, or a failed add left it disabled). No
       scroll: row 5 sits where the bar was. A failed focus move never undoes
       the reveal. Known cost, accepted for launch: a held or doubled Enter
       or Space then activates row 5's "Add" too. Do not focus the row
       instead: with "Add" on it would read the title twice. */
    function expandItems(bar) {
      if (!setExpanded(bar, true)) return;
      try {
        var rows = expanderRows(bar);
        var row = rows && rows[VISIBLE_ROWS];
        if (!row) return;
        var add = row.querySelector('[data-action="add-item"]');
        if (add && !add.disabled) {
          add.focus({ preventScroll: true });
        } else {
          row.setAttribute('tabindex', '-1');
          row.focus({ preventScroll: true });
        }
      } catch (err) {
        /* The rows are revealed; only the focus move is lost. */
      }
    }

    /* Collapse (H1): the bar keeps its place on screen (keepInPlace). Focus
       inside a row being hidden moves to the bar; otherwise it stays where it
       is. With the keyboard it is already on the bar, but Safari (iOS and
       macOS) and Firefox on macOS do not focus a clicked button, so a tap
       must never be assumed to have focused it. No live-region message on
       either action: it would compete with the focus announcement. */
    function collapseItems(bar) {
      var rows = expanderRows(bar);
      var active = document.activeElement;
      var focusInHidden = false;
      if (rows && active) {
        for (var i = VISIBLE_ROWS; i < rows.length; i++) {
          if (rows[i].contains(active)) {
            focusInHidden = true;
            break;
          }
        }
      }

      keepInPlace(bar, function () {
        setExpanded(bar, false);
      });

      if (focusInHidden) {
        try {
          bar.focus({ preventScroll: true });
        } catch (err) {
          /* The list is collapsed; only the focus move is lost. */
        }
      }
    }

    root.addEventListener('click', function (e) {
      var bar = e.target.closest('[data-action="toggle-items"]');
      if (!bar) return;
      if (bar.getAttribute('data-expanded') === 'true') {
        collapseItems(bar);
      } else {
        expandItems(bar);
      }
    });

    root.querySelectorAll('[data-action="toggle-items"]').forEach(function (bar) {
      try {
        if (!expanderRows(bar)) return;
        /* An order opened natively before this deferred script arrived keeps
           every row: nothing collapses under the customer. */
        var details = bar.closest('details');
        var startExpanded = !!(details && details.open);
        bar.removeAttribute('hidden');
        setExpanded(bar, startExpanded);
      } catch (err) {
        /* Skip this order: its rows stay visible. */
      }
    });

    /* =====================================================================
       1. ONLY-ONE-OPEN ACCORDION + ANIMATION
       ===================================================================== */

    /* The pending animation on each wrapper: the frame callback that starts
       it and the listener that finishes it. Kept so that a new animation or
       an instant close cancels both. A close's listener left attached used to
       shut the order at the end of its next opening (B2C-323). */
    var pendingAnimations = new WeakMap();

    function cancelPending(wrapper) {
      var pending = pendingAnimations.get(wrapper);
      if (!pending) return;
      if (pending.frame) cancelAnimationFrame(pending.frame);
      wrapper.removeEventListener('transitionend', pending.onEnd);
      pendingAnimations.delete(wrapper);
    }

    /* Cancel whatever is pending, run `start` on the next frame, and `finish`
       when the wrapper's OWN max-height transition ends. Buttons, the bar and
       the chevron inside the panel transition too, and their transitionend
       bubbles up to the wrapper: none of them may end an open or a close. */
    function animateWrapper(wrapper, start, finish) {
      cancelPending(wrapper);
      var pending = { frame: 0, onEnd: null };
      pending.frame = requestAnimationFrame(function () {
        pending.frame = 0;
        start();
      });
      pending.onEnd = function (e) {
        if (e.target !== wrapper || e.propertyName !== 'max-height') return;
        cancelPending(wrapper);
        finish();
      };
      wrapper.addEventListener('transitionend', pending.onEnd);
      pendingAnimations.set(wrapper, pending);
    }

    /**
     * Animate the detail wrapper open.
     * Sets max-height from 0 to scrollHeight, then removes it after transition.
     */
    function openDetail(detailsEl) {
      var wrapper = detailsEl.querySelector('.c-account-orders__detail-wrapper');
      if (!wrapper) return;

      /* Ensure [open] is set so we can measure */
      detailsEl.open = true;
      var height = wrapper.scrollHeight;
      wrapper.style.maxHeight = '0px';
      wrapper.style.overflow = 'clip';

      animateWrapper(wrapper, function () {
        wrapper.style.maxHeight = height + 'px';
      }, function () {
        /* Allow content to be naturally sized after animation */
        wrapper.style.maxHeight = 'none';
        wrapper.style.overflow = 'visible';
      });
    }

    /**
     * Animate the detail wrapper closed.
     * Sets max-height to current height then animates to 0, removes [open] after.
     */
    function closeDetail(detailsEl) {
      var wrapper = detailsEl.querySelector('.c-account-orders__detail-wrapper');
      if (!wrapper) return;

      var height = wrapper.scrollHeight;
      wrapper.style.maxHeight = height + 'px';
      wrapper.style.overflow = 'clip';

      animateWrapper(wrapper, function () {
        wrapper.style.maxHeight = '0px';
      }, function () {
        detailsEl.open = false;
        wrapper.style.maxHeight = '';
        wrapper.style.overflow = '';
      });
    }

    /**
     * Close the detail at once, with no animation. Cancels any open or close
     * still pending on the wrapper and clears its inline sizing. The rows are
     * not touched: a closed order keeps its expanded or collapsed list (D31
     * trade-off 3). Used by the filter tabs and by the order switch (H2).
     */
    function closeDetailNow(detailsEl) {
      var wrapper = detailsEl.querySelector('.c-account-orders__detail-wrapper');
      if (wrapper) cancelPending(wrapper);
      detailsEl.open = false;
      if (wrapper) {
        wrapper.style.maxHeight = '';
        wrapper.style.overflow = '';
      }
    }

    /**
     * Close all other details elements except the given one.
     */
    function closeOthers(exceptEl) {
      allDetails.forEach(function (d) {
        if (d !== exceptEl && d.open) {
          closeDetail(d);
        }
      });
    }

    /* Every open order above `detailsEl`, in document order. */
    function openAbove(detailsEl) {
      var above = [];
      for (var i = 0; i < allDetails.length && allDetails[i] !== detailsEl; i++) {
        if (allDetails[i].open) above.push(allDetails[i]);
      }
      return above;
    }

    /* Listen for click on each summary to intercept toggle behavior */
    allDetails.forEach(function (d) {
      var summary = d.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        if (d.open) {
          closeDetail(d);
        } else {
          /* H2 (B2C-323): every open order ABOVE the tapped one closes at
             once, and one instant scroll keeps the tapped summary where it
             was tapped. Every one of them, whatever its state: find-in-page
             and native opens made before this script can leave more than one
             open, and one may still be opening or closing. Wrapped: a failure
             here must never close the order above and then open nothing. */
          try {
            var above = openAbove(d);
            if (above.length) {
              keepInPlace(summary, function () {
                above.forEach(function (other) { closeDetailNow(other); });
              });
            }
          } catch (err) {
            /* closeOthers below still closes them, animated. */
          }

          /* Open orders below cannot move the tapped summary: they keep the
             animated close. */
          closeOthers(d);
          openDetail(d);
        }
      });
    });

    /* =====================================================================
       2. FILTER TABS
       ===================================================================== */

    var FILTER_MAP = {
      all: null,
      processing: 'processing',
      delivered: 'delivered',
      cancelled: 'cancelled'
    };

    filterTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var filterValue = tab.getAttribute('data-filter');

        /* Update active state */
        filterTabs.forEach(function (t) {
          t.classList.remove('c-account-orders__filter-tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('c-account-orders__filter-tab--active');
        tab.setAttribute('aria-selected', 'true');

        /* Close any open details first */
        allDetails.forEach(function (d) {
          if (d.open) closeDetailNow(d);
        });

        /* Show/hide cards */
        var visibleCount = 0;
        cards.forEach(function (card) {
          var status = card.getAttribute('data-fulfillment-status');
          if (filterValue === 'all' || status === FILTER_MAP[filterValue]) {
            card.removeAttribute('hidden');
            visibleCount++;
          } else {
            card.setAttribute('hidden', '');
          }
        });

        /* Announce to screen readers */
        if (liveRegion) {
          liveRegion.textContent = visibleCount + ' orders';
        }
      });
    });

    /* =====================================================================
       3. DEEP LINKING
       ===================================================================== */

    function handleDeepLink() {
      var params = new URLSearchParams(window.location.search);
      var orderName = params.get('order');
      if (!orderName) return;

      var target = root.querySelector(
        'details[data-order-name="' + CSS.escape(orderName) + '"]'
      );
      if (!target) return;

      /* Ensure the card is visible (switch to All filter if needed) */
      var card = target.closest('.c-account-orders__card');
      if (card && card.hasAttribute('hidden')) {
        /* Activate the "All" filter */
        filterTabs.forEach(function (t) {
          t.classList.remove('c-account-orders__filter-tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        var allTab = root.querySelector('[data-filter="all"]');
        if (allTab) {
          allTab.classList.add('c-account-orders__filter-tab--active');
          allTab.setAttribute('aria-selected', 'true');
        }
        cards.forEach(function (c) { c.removeAttribute('hidden'); });
      }

      /* Open the target card */
      openDetail(target);

      /* Scroll into view after a brief delay for animation.
         Use the parent card which has scroll-margin-block-start. */
      setTimeout(function () {
        var scrollTarget = target.closest('.c-account-orders__card') || target;
        var headerH = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'), 10) || 160;
        var top = scrollTarget.getBoundingClientRect().top + window.scrollY - headerH - 16;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }, 100);
    }

    /* Run deep link on DOMContentLoaded or immediately if already loaded */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', handleDeepLink);
    } else {
      handleDeepLink();
    }

    /* =====================================================================
       4. ADD TO CART — PER ITEM
       ===================================================================== */

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action="add-item"]');
      if (!btn) return;

      var variantId = btn.getAttribute('data-variant-id');
      var quantity = parseInt(btn.getAttribute('data-quantity'), 10) || 1;
      var labelDefault = btn.getAttribute('data-label-default');
      var labelAdded = btn.getAttribute('data-label-added');
      var labelUnavailable = btn.getAttribute('data-label-unavailable');

      if (!variantId || btn.disabled) return;

      var api = cartApi();
      if (!api) {
        btn.textContent = labelUnavailable;
        btn.setAttribute('data-state', 'unavailable');
        return;
      }

      var ceilings = ceilingParams(btn.closest('.c-account-orders__line-item'));

      btn.disabled = true;
      btn.textContent = '...';

      api.add({
        id: variantId,
        quantity: quantity,
        productId: ceilings.productId,
        cap: ceilings.cap,
        stock: ceilings.stock,
        orderLimitMessage: ceilings.orderLimitMessage
      })
        .then(function (result) {
          btn.disabled = false;

          if (!result.ok) {
            /* Refused at a ceiling. The wrapper has already explained which
               one, so the row just stands down: the label returns to its
               default and nothing claims the item was added. This is not the
               "unavailable" state — the product exists, the quantity does not. */
            btn.textContent = labelDefault;
            btn.removeAttribute('data-state');
            return;
          }

          btn.textContent = labelAdded;
          btn.setAttribute('data-state', 'added');

          notifyCartUpdate();

          setTimeout(function () {
            btn.textContent = labelDefault;
            btn.removeAttribute('data-state');
          }, 2000);
        })
        .catch(function () {
          btn.textContent = labelUnavailable;
          btn.setAttribute('data-state', 'unavailable');
          /* Leave disabled — item is unavailable */
        });
    });

    /* =====================================================================
       5. REORDER ALL
       ===================================================================== */

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action="reorder-all"]');
      if (!btn) return;

      var accordion = btn.closest('.c-account-orders__accordion');
      if (!accordion) return;

      var lineItems = accordion.querySelectorAll('.c-account-orders__line-item');
      var items = [];

      lineItems.forEach(function (row) {
        var vid = row.getAttribute('data-variant-id');
        var qty = parseInt(row.getAttribute('data-quantity'), 10) || 1;
        if (vid) {
          var c = ceilingParams(row);
          items.push({
            id: parseInt(vid, 10),
            quantity: qty,
            productId: c.productId,
            title: c.title,
            cap: c.cap,
            stock: c.stock
          });
        }
      });

      if (items.length === 0) return;

      var labelDefault = btn.getAttribute('data-label-default');
      var labelAdding = btn.getAttribute('data-label-adding');
      var labelSuccess = btn.getAttribute('data-label-success');

      var api = cartApi();
      if (!api || !api.addMany) return;

      btn.disabled = true;
      btn.textContent = labelAdding;

      /* ONE call for the whole order. The allocation inside addMany is
         cumulative, so two rows sharing a product draw on one cap ledger and
         the second sees what the first took — which N parallel adds could not
         do, and which N sequential ones bought at N round trips. */
      api.addMany(items)
        .then(function (result) {
          btn.disabled = false;

          /* `ceilings` is index-aligned to `items`; `result.items` is the raw
             /cart/add.js response and is NOT — never pair them. The product
             title lives here, on the row, which is why the pairing is this
             block's job. */
          var blocked = [];
          for (var i = 0; i < items.length; i++) {
            if (result.ceilings[i]) {
              blocked.push({ title: items[i].title, ceiling: result.ceilings[i] });
            }
          }

          /* One cart:update for the whole press, not one per line. */
          if (result.items.length) { notifyCartUpdate(); }

          if (blocked.length) {
            /* The toast carries the whole story — which items were refused and
               why — so the button says nothing about a partial result. */
            announceBlocked(blocked);
            btn.textContent = labelDefault;
            return;
          }
          if (!result.items.length) {
            /* Nothing landed and nothing was refused at a ceiling: the batch
               was turned down for a reason we cannot attribute to a line. */
            btn.textContent = labelDefault;
            return;
          }

          btn.textContent = labelSuccess;
          setTimeout(function () {
            btn.textContent = labelDefault;
          }, 3000);
        })
        .catch(function () {
          /* Network failure or a non-422 refusal. Leave the control usable
             rather than stuck on "Adding…". */
          btn.disabled = false;
          btn.textContent = labelDefault;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_account-profile"] && !Shopify.designMode) return;
  try {
    /* Account profile — region selector + live region display
     ---------------------------------------------------------------- */
  (function () {
    /* Wire "Change" button to open the region selector */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-open-region-selector]');
      if (!btn) return;
      e.preventDefault();
      if (window.CasinettoDelivery && window.CasinettoDelivery.openSelector) {
        window.CasinettoDelivery.openSelector();
      }
    });

    /* Update the region display when delivery engine writes to localStorage */
    function updateRegionDisplay() {
      var el = document.querySelector('[data-account-region-display]');
      if (!el) return;
      try {
        var region = localStorage.getItem('casinetto_delivery_region') || '';
        var district = localStorage.getItem('casinetto_delivery_district') || '';
        var display = '';
        if (district && region) {
          display = district + ', ' + region;
        } else {
          display = district || region || '';
        }
        if (display) {
          el.textContent = display;
        }
      } catch (_) { /* localStorage not available */ }
    }

    /* Listen for storage events (cross-tab) and custom delivery events */
    window.addEventListener('storage', function (e) {
      if (e.key === 'casinetto_delivery_region' || e.key === 'casinetto_delivery_district') {
        updateRegionDisplay();
      }
    });

    /* Poll briefly after selector closes (same-tab localStorage writes
       don't trigger storage events) */
    var observer = new MutationObserver(function () {
      updateRegionDisplay();
    });
    var selectorEl = document.querySelector('[data-region-selector]');
    if (selectorEl) {
      observer.observe(selectorEl, { attributes: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    // Floating filter pill — show when inline .facets-toggle scrolls out of viewport.
  // The state is html[data-filter-pill], not an attribute of the pill: the section
  // morph on every filter change reset the pill to its server markup (B2C-363).
  (function () {
    var pill = document.querySelector('.c-filter-pill');
    var sentinel = document.querySelector('.facets-toggle');
    if (!pill || !sentinel) return;
    var mq = window.matchMedia('(max-width: 749px)');
    if (!mq.matches) return;

    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (entry.boundingClientRect.top < 0 && !entry.isIntersecting) {
        document.documentElement.dataset.filterPill = 'visible';
      } else {
        delete document.documentElement.dataset.filterPill;
      }
    }, { threshold: 0 });

    io.observe(sentinel);
  })();

  // Desktop: a filter or sort change made deep in the grid brings the results
  // back under the header (B2C-363). filter:update fires before the morph, and
  // the toolbar sits above the grid, so its position is already final. Instant,
  // never downwards; focus and the sticky panel's own scroll are left alone.
  (function () {
    var mq = window.matchMedia('(min-width: 750px)');

    document.addEventListener('filter:update', function () {
      if (!mq.matches) return;
      var toolbar = document.querySelector('.facets--horizontal.facets-controls-wrapper');
      var panel = document.querySelector('.facets-block-wrapper .facets--vertical');
      if (!toolbar || !panel) return;

      // The sticky panel's offset is the header height plus the gap (casinetto.css).
      var offset = parseFloat(getComputedStyle(panel).insetBlockStart);
      if (isNaN(offset)) offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-sticky-h')) || 0;

      var top = toolbar.getBoundingClientRect().top;
      if (top >= offset) return;
      window.scrollBy({ top: top - offset, behavior: 'instant' });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
